// extracted by mini-css-extract-plugin
export default {"iconLabel":"IconLabel_iconLabel__Bq28g","iconLabel__icon":"IconLabel_iconLabel__icon__i2D1f","iconLabel__title":"IconLabel_iconLabel__title__KWtCY"};